module.exports = __webpack_public_path__ + "img/icon03.80c186e8.png";